import React from 'react';
import { Input } from 'reactstrap';
import { parseTelephone } from '../../utils';

class Phone extends React.Component {

    handleOnNumberChange = (e) => {
        var newPhone = parseTelephone(e.target.value);
        newPhone.isValid = e.target.validity.valid;
        this.props.onChange && this.props.onChange(newPhone);
    }

    render() {
        const { toggleContactPhoneIsValid } = this.props;
        const phone = this.props.phone ?? { isValid: false, formattedNumber: '', secondaryPhone: null };
        const formattedNumber = phone.formattedNumber;
        return (
            <Input type="tel" id={this.props.id || 'phone'} name="phone"
                placeholder="123-456-7890"
                pattern="[0-9]{3}-[0-9]{3}-[0-9]{4}"
                required
                value={formattedNumber}
                onChange={this.handleOnNumberChange}
                maxLength={12}
                valid={phone.isValid === undefined ? formattedNumber && toggleContactPhoneIsValid(true) : phone.isValid && toggleContactPhoneIsValid(true)}
                invalid={!phone && !(phone.isValid === undefined ? formattedNumber && toggleContactPhoneIsValid(false) : phone.isValid) && toggleContactPhoneIsValid(false)}
            />

        )
    }
}

export default Phone